export const routes = [
  {
    path: '/',
    name: '/',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/index.vue'),
    /* no children */
  },
  {
    path: '/academy',
    /* internal name: '/academy' */
    /* no component */
    children: [
      {
        path: '',
        name: '/academy/',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        /* internal name: '/academy/[id]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/academy/[id]/',
            component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/index.vue'),
            /* no children */
          },
          {
            path: ':season',
            /* internal name: '/academy/[id]/[season]' */
            /* no component */
            children: [
              {
                path: 'info',
                name: '/academy/[id]/[season]/info',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/info.vue'),
                /* no children */
              },
              {
                path: 'schedule',
                name: '/academy/[id]/[season]/schedule',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/schedule.vue'),
                /* no children */
              },
              {
                path: 'scores',
                name: '/academy/[id]/[season]/scores',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/scores.vue'),
                /* no children */
              },
              {
                path: 'seasons',
                name: '/academy/[id]/[season]/seasons',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/seasons.vue'),
                /* no children */
              },
              {
                path: 'standings',
                name: '/academy/[id]/[season]/standings',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/standings.vue'),
                /* no children */
              },
              {
                path: 'statistics',
                name: '/academy/[id]/[season]/statistics',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/statistics.vue'),
                /* no children */
              },
              {
                path: 'statistics__',
                name: '/academy/[id]/[season]/statistics__',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/statistics__.vue'),
                /* no children */
              },
              {
                path: 'stats',
                /* internal name: '/academy/[id]/[season]/stats' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/academy/[id]/[season]/stats/',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/stats/index.vue'),
                    /* no children */
                  },
                  {
                    path: 'goalies',
                    name: '/academy/[id]/[season]/stats/goalies',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/stats/goalies.vue'),
                    /* no children */
                  },
                  {
                    path: 'skaters',
                    name: '/academy/[id]/[season]/stats/skaters',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/stats/skaters.vue'),
                    /* no children */
                  },
                  {
                    path: 'teams',
                    name: '/academy/[id]/[season]/stats/teams',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/stats/teams.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'stats copy',
                name: '/academy/[id]/[season]/stats copy',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/[season]/stats copy.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'schedule',
            name: '/academy/[id]/schedule',
            component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/academy/[id]/schedule.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/account',
    name: '/account',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/account.vue'),
    /* no children */
  },
  {
    path: '/articles',
    /* internal name: '/articles' */
    /* no component */
    children: [
      {
        path: '',
        name: '/articles/',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/articles/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/articles/[id]',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/articles/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/cancel-email-change',
    name: '/cancel-email-change',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/cancel-email-change.vue'),
    /* no children */
  },
  {
    path: '/confirm-email-change',
    name: '/confirm-email-change',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/confirm-email-change.vue'),
    /* no children */
  },
  {
    path: '/confirm-handover',
    name: '/confirm-handover',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/confirm-handover.vue'),
    /* no children */
  },
  {
    path: '/contact-hockeybook',
    name: '/contact-hockeybook',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/contact-hockeybook.vue'),
    /* no children */
  },
  {
    path: '/contact-modernhockey',
    name: '/contact-modernhockey',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/contact-modernhockey.vue'),
    /* no children */
  },
  {
    path: '/dependants',
    name: '/dependants',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/dependants.vue'),
    /* no children */
  },
  {
    path: '/event',
    /* internal name: '/event' */
    /* no component */
    children: [
      {
        path: ':id',
        name: '/event/[id]',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/event/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/eventdatalog',
    /* internal name: '/eventdatalog' */
    /* no component */
    children: [
      {
        path: ':id',
        name: '/eventdatalog/[id]',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/eventdatalog/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/events',
    /* internal name: '/events' */
    /* no component */
    children: [
      {
        path: ':id',
        name: '/events/[id]',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/events/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/gamecenter',
    /* internal name: '/gamecenter' */
    /* no component */
    children: [
      {
        path: ':id',
        name: '/gamecenter/[id]',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/gamecenter/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/gdpr-hockeybook',
    name: '/gdpr-hockeybook',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/gdpr-hockeybook.vue'),
    /* no children */
  },
  {
    path: '/gdpr-modernhockey',
    name: '/gdpr-modernhockey',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/gdpr-modernhockey.vue'),
    /* no children */
  },
  {
    path: '/hrat-superligu',
    name: '/hrat-superligu',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/hrat-superligu.vue'),
    /* no children */
  },
  {
    path: '/leagues',
    /* internal name: '/leagues' */
    /* no component */
    children: [
      {
        path: '',
        name: '/leagues/',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        /* internal name: '/leagues/[id]' */
        /* no component */
        children: [
          {
            path: '',
            name: '/leagues/[id]/',
            component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/index.vue'),
            /* no children */
          },
          {
            path: ':season',
            name: '/leagues/[id]/[season]',
            component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season].vue'),
            children: [
              {
                path: '',
                name: '/leagues/[id]/[season]/',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/index.vue'),
                /* no children */
              },
              {
                path: 'addarticle',
                /* internal name: '/leagues/[id]/[season]/addarticle' */
                /* no component */
                children: [
                  {
                    path: ':articleId?',
                    name: '/leagues/[id]/[season]/addarticle/[[articleId]]',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/addarticle/[[articleId]].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'articles',
                name: '/leagues/[id]/[season]/articles',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/articles.vue'),
                children: [
                  {
                    path: ':urlTitle',
                    name: '/leagues/[id]/[season]/articles/[urlTitle]',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/articles/[urlTitle].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'info',
                name: '/leagues/[id]/[season]/info',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/info.vue'),
                /* no children */
              },
              {
                path: 'playoff',
                name: '/leagues/[id]/[season]/playoff',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/playoff.vue'),
                /* no children */
              },
              {
                path: 'schedule',
                name: '/leagues/[id]/[season]/schedule',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/schedule.vue'),
                /* no children */
              },
              {
                path: 'scores',
                name: '/leagues/[id]/[season]/scores',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/scores.vue'),
                /* no children */
              },
              {
                path: 'seasons',
                name: '/leagues/[id]/[season]/seasons',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/seasons.vue'),
                /* no children */
              },
              {
                path: 'standings',
                name: '/leagues/[id]/[season]/standings',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/standings.vue'),
                /* no children */
              },
              {
                path: 'statis',
                name: '/leagues/[id]/[season]/statis',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/statis.vue'),
                /* no children */
              },
              {
                path: 'statistics',
                name: '/leagues/[id]/[season]/statistics',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/statistics.vue'),
                /* no children */
              },
              {
                path: 'stats',
                /* internal name: '/leagues/[id]/[season]/stats' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: '/leagues/[id]/[season]/stats/',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/stats/index.vue'),
                    /* no children */
                  },
                  {
                    path: 'goalies',
                    name: '/leagues/[id]/[season]/stats/goalies',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/stats/goalies.vue'),
                    /* no children */
                  },
                  {
                    path: 'skaters',
                    name: '/leagues/[id]/[season]/stats/skaters',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/stats/skaters.vue'),
                    /* no children */
                  },
                  {
                    path: 'teams',
                    name: '/leagues/[id]/[season]/stats/teams',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/stats/teams.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'treasury',
                name: '/leagues/[id]/[season]/treasury',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/[season]/treasury.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'academy',
            name: '/leagues/[id]/academy',
            component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/academy.vue'),
            children: [
              {
                path: 'addarticle',
                /* internal name: '/leagues/[id]/academy/addarticle' */
                /* no component */
                children: [
                  {
                    path: ':articleId?',
                    name: '/leagues/[id]/academy/addarticle/[[articleId]]',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/academy/addarticle/[[articleId]].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'articles',
                name: '/leagues/[id]/academy/articles',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/academy/articles.vue'),
                children: [
                  {
                    path: ':urlTitle',
                    name: '/leagues/[id]/academy/articles/[urlTitle]',
                    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/academy/articles/[urlTitle].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'schedule',
                name: '/leagues/[id]/academy/schedule',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/academy/schedule.vue'),
                /* no children */
              },
              {
                path: 'treasury',
                name: '/leagues/[id]/academy/treasury',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/academy/treasury.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'articles',
            name: '/leagues/[id]/articles',
            component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/articles.vue'),
            children: [
              {
                path: ':urlTitle',
                name: '/leagues/[id]/articles/[urlTitle]',
                component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/leagues/[id]/articles/[urlTitle].vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/login',
    name: '/login',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/login.vue'),
    /* no children */
  },
  {
    path: '/MessageCenterPage',
    name: '/MessageCenterPage',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/MessageCenterPage.vue'),
    /* no children */
  },
  {
    path: '/messages',
    /* internal name: '/messages' */
    /* no component */
    children: [
      {
        path: '',
        name: '/messages/',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/messages/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/newarticle',
    /* internal name: '/newarticle' */
    /* no component */
    children: [
      {
        path: '',
        name: '/newarticle/',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/newarticle/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/newarticle/[id]',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/newarticle/[id].vue'),
        /* no children */
      },
      {
        path: ':id?',
        name: '/newarticle/[[id]]',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/newarticle/[[id]].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/organisations',
    name: '/organisations',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/organisations.vue'),
    /* no children */
  },
  {
    path: '/password',
    name: '/password',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/password.vue'),
    /* no children */
  },
  {
    path: '/players',
    name: '/players',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/players.vue'),
    /* no children */
  },
  {
    path: '/register',
    name: '/register',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/register.vue'),
    /* no children */
  },
  {
    path: '/register-dependent',
    name: '/register-dependent',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/register-dependent.vue'),
    /* no children */
  },
  {
    path: '/teams',
    /* internal name: '/teams' */
    /* no component */
    children: [
      {
        path: '',
        name: '/teams/',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/teams/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/teams/[id]',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/teams/[id].vue'),
        children: [
          {
            path: '',
            name: '/teams/[id]/',
            component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/teams/[id]/index.vue'),
            /* no children */
          },
          {
            path: 'members',
            name: '/teams/[id]/members',
            component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/teams/[id]/members.vue'),
            /* no children */
          },
          {
            path: 'schedule',
            name: '/teams/[id]/schedule',
            component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/teams/[id]/schedule.vue'),
            /* no children */
          },
          {
            path: 'treasury',
            name: '/teams/[id]/treasury',
            component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/teams/[id]/treasury.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/unsubscribe',
    /* internal name: '/unsubscribe' */
    /* no component */
    children: [
      {
        path: '',
        name: '/unsubscribe/',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/unsubscribe/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/users',
    /* internal name: '/users' */
    /* no component */
    children: [
      {
        path: 'userList',
        name: '/users/userList',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/users/userList.vue'),
        /* no children */
      },
      {
        path: 'userProfile',
        name: '/users/userProfile',
        component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/users/userProfile.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/verify-email',
    name: '/verify-email',
    component: () => import('/Users/miroslavskala/Documents/Projekty/team-manager/team-manager-app/src/pages/verify-email.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

